import { Button } from 'primereact/button';
import { Dialog } from 'primereact/dialog';
import { Divider } from 'primereact/divider';
import React from 'react';
import { useSelector } from 'react-redux';

import { AGENTROLE } from '../../../../constants';
import { selectCurrentRole } from '../../../../pages/login/authSlice';
import { AgentGuidline } from './AgentGuidline';
import { ManagerGuidline } from './ManagerGuidline';

export const MetricGuideline = (props: any) => {
    const role = useSelector(selectCurrentRole);

    const onDialogHide = () => {
        props?.setDisplayGuidline(false);
    };

    const renderHeader = () => {
        return (
            <div>
                <h3>Metrics </h3>
                <Button
                    label="Return to Metrics"
                    onClick={() => props?.setDisplayGuidline(false)}
                    className="btn-primary float-end"
                />
            </div>
        );
    };

    return (
        <Dialog
            header={renderHeader()}
            footer={
                <div id="guidelineFooter">
                    <p style={{ fontStyle: 'italic', marginBottom: '0px' }}>
                        Quote: My mission in life is not merely to survive but to <strong> THRIVE </strong>
                    </p>
                    <p className="guidelines">- Maya Angelou</p>
                </div>
            }
            visible={props?.displayGuidline}
            onHide={onDialogHide}
            style={{ width: '1120px', height: '90vh' }}
            // position="top-right"
            className="card shadow bg-body rounded mt-4 border-0 w-65"
            modal
            draggable={false}
            resizable={false}
        >
            <Divider />
            {role === AGENTROLE ? <AgentGuidline /> : <ManagerGuidline />}
        </Dialog>
    );
};
